export enum ListingType {
	cards = 'card',
	rows = 'row'
}
